import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/payment-channels";

export type listType = {
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
  type_channel_payment?:string;
};

export class PaymentChannelApi extends BaseAPI {
  static getPaymentChannelByType(query?: listType): Promise<AxiosResponse> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }

  static updatePaymentChannel(id: number, body: FormData): Promise<any> {
    return this.api.post(`${path}/${id}`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

}
